import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { IssuuEmbed as Original } from 'components/organisms'
import { IssuuEmbedSettings, IssuuEmbedFloatingSettings } from './IssuuEmbedSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {
  issuuId: '',
}

export const dynamicProps = []

export const IssuuEmbed: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-issuu-embed ${props.className}`}>
        <Original issuuId={blockProps.issuuId} editMode={enabled} />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

IssuuEmbed.craft = withCraft({
  name: 'IssuuEmbed',
  defaultProps: defaultProps,
  settings: IssuuEmbedSettings,
  floatingSettings: IssuuEmbedFloatingSettings,
})
